function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  d: "m14.168.626-4.67 11.142H6.45L4.153 2.876c-.14-.548-.261-.748-.686-.979C2.775 1.521 1.631 1.17.624.95L.692.626h4.905c.625 0 1.187.416 1.329 1.136L8.14 8.209l3-7.583h3.028zM26.106 8.13c.012-2.94-4.067-3.102-4.039-4.416.009-.4.39-.825 1.223-.933.413-.055 1.55-.096 2.841.498l.507-2.363a7.745 7.745 0 0 0-2.696-.494c-2.85 0-4.854 1.515-4.871 3.684-.019 1.604 1.43 2.499 2.523 3.032 1.123.545 1.5.896 1.496 1.384-.008.748-.896 1.078-1.726 1.09-1.449.023-2.29-.391-2.96-.703l-.522 2.441c.674.31 1.917.579 3.205.592 3.029 0 5.01-1.495 5.019-3.812zm7.523 3.638h2.665L33.968.626h-2.461c-.553 0-1.02.322-1.227.817l-4.325 10.325h3.027l.6-1.664h3.699l.348 1.664zM30.413 7.82l1.517-4.183.873 4.183h-2.39zM18.286.626l-2.384 11.142H13.02L15.405.626h2.88z",
  fill: "#1434CB"
});

var SvgVisa = function SvgVisa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 37,
    height: 12,
    viewBox: "0 0 37 12",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVisa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/visa.5a36f2a1.svg";
export { ForwardRef as ReactComponent };